import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/Login";
import AppShell from "./components/AppShell";
import Dashboard from "./pages/Dashboard";
import Devices from "./pages/Devices";
import Tags from "./pages/Tags";
import Alarms from "./pages/Alarms";
import Trends from "./pages/Trends";
import MimicList from "./pages/MimicList";
import MimicEditor from "./pages/MimicEditor";
import MimicViewer from "./pages/MimicViewer";
import Sites from "./pages/Sites";
import Users from "./pages/Users";
import Reports from "./pages/Reports";
import Ingestion from "./pages/Ingestion";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#9BA4B5] font-mono-metric tracking-widest text-sm">INITIALIZING SYSTEM…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && roles.length && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function ShellLayout() {
  return (
    <AppShell><Outlet /></AppShell>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/mimics/view/:id" element={<Protected><MimicViewer /></Protected>} />
          <Route element={<Protected><ShellLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/alarms" element={<Alarms />} />
            <Route path="/trends" element={<Trends />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/mimics" element={<MimicList />} />
            <Route path="/mimics/edit/:id" element={<Protected roles={["super_admin","plant_admin","admin"]}><MimicEditor /></Protected>} />
            <Route path="/sites" element={<Protected roles={["super_admin","admin"]}><Sites /></Protected>} />
            <Route path="/devices" element={<Protected roles={["super_admin","plant_admin","admin"]}><Devices /></Protected>} />
            <Route path="/tags" element={<Protected roles={["super_admin","plant_admin","admin"]}><Tags /></Protected>} />
            <Route path="/ingestion" element={<Protected roles={["super_admin","plant_admin","admin"]}><Ingestion /></Protected>} />
            <Route path="/users" element={<Protected roles={["super_admin","admin"]}><Users /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
